define('shared/initializer/form/adapters/mixins/fields/AgeYoungerThanThirteen',[
    'shared/lib/RSVP',
    '../../../constants'
], 
function(
    RSVP,
    constants
) {
    'use strict';

    function Ctor(){}

    Ctor.prototype.doPageLoad = function(){
        var me = this;
        var fieldAge = me.items[constants.FIELD.Age.toLowerCase()];

        if (fieldAge != null) {
            fieldAge.validate = function(value, options){
                if (value === '<13' ) {
                    return RSVP.reject(
                        fieldAge.messages && fieldAge.messages['not-acceptable'] || 
                        (options && options.message) || 
                        'Age younger than 13 is not allowed to be registered'
                    );
                }
                else {
                    return RSVP.resolve();
                }
            };   
        }

        return RSVP.resolve();
    };

    return Ctor;
});
